
import { mapState, mapGetters } from 'vuex'

export default {
  props: ['facets', 'facetsValues'],
  data () {
    return { visibleFacet: 'visibility' }
  },
  computed: {
    ...mapState(['vocabulary', 'env']),
    ...mapGetters(['activeAccountPublicationSitesById']),
    ...mapGetters('session', ['activeAccount']),
    showOwnerFacets () {
      if (!this.facets.owner) return false
      if (!this.activeAccount.department && this.facets.owner.find(o => !!o.value.department)) return true
      return false
    }
  },
  methods: {
    publicationSiteText (item) {
      let title = item.value
      if (item.value === null) title = 'aucun'
      else {
        const publicationSite = this.activeAccountPublicationSitesById && this.activeAccountPublicationSitesById[item.value]
        if (publicationSite) {
          title = publicationSite.title || publicationSite.url || publicationSite.id
        }
      }
      return `${title} (${item.count})`
    }
  }
}
